<template>
    <b-modal ref="profile_modal" size="xl" bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>
        
        <template v-slot:modal-header="{ close }">
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        
        <div id="panel_users_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2><span class="fw-300">ID:{{this.doc.id}}</span></h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
            
            <div class="p-1" v-if="!is_load">
                
                <div class="template p-3">
                    <users_select
                        @on_item_set="set_user_id"
                        :active_id="parseInt(doc.user_id)">
                    </users_select>
                </div>
                
                <div class="template p-3">
                    <organization_select
                        label="Організація власник"
                        @on_organization_set="set_tov_id"
                        :active_id="parseInt(doc.tov_id)">
                    </organization_select>
                </div>
                
                <div class="template p-3">
                    <equipment_type_select
                        @on_item_set="set_type_id"
                        :active_id="parseInt(doc.type_id)"
                    >
                    </equipment_type_select>
                </div>
                
                <div class="template p-3">
                    <label class="form-label" for="payment_online">
                        Характеристики
                    </label>
                    
                    <div class="select_step">
                        <b-textarea v-model="doc.description" :rows="5"></b-textarea>
                    </div>
                </div>
                
                <div class="template p-3">
                    <label class="form-label" for="payment_online">
                        Інвентарний номер
                    </label>
                    
                    <div class="select_step">
                        <b-input v-model="doc.number"></b-input>
                    </div>
                </div>
                
                <div class="template p-3">
                    <label class="form-label" for="payment_online">
                        Ціна
                    </label>
                    <div class="select_step">
                        <b-input v-model="doc.price"></b-input>
                    </div>
                </div>
                
                <div class="template p-3">
                    <label class="form-label" for="payment_online">
                        Коментар
                    </label>
                    
                    <div class="select_step">
                        <b-textarea v-model="doc.comment" :rows="3"></b-textarea>
                    </div>
                </div>
                
                <div class="template p-3">
                    <users_admin_select
                        @on_item_set="set_admin_user_id"
                        :active_id="parseInt(doc.init_user)">
                    </users_admin_select>
                </div>
                
            </div>
        </div>
        <template v-slot:modal-footer="{close}">
            <div class="modal-footer w-100">
                
                <button type="button" v-on:click="remove_item" class="btn btn-outline-danger waves-effect waves-themed mr-5">
                    Видалити
                </button>
                
                <button type="button" v-on:click="close_modal" class="btn btn-secondary waves-effect waves-themed ml-5">
                    Закрити
                </button>
                
                <button type="button" v-on:click="save_doc" class="btn btn-success waves-effect waves-themed">
                    Зберегти
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script >
import Organization_select from "../../shared/select/organization_select.vue";
import Equipment_type_select from "../../shared/select/equipment_type_select.vue";
import Users_select from "../../shared/select/users_select.vue";
import users_admin_select from "../../shared/select/users_admin_select.vue";

export default {
    name: "equipment_editor",
    components: {
        Users_select,
        Equipment_type_select,
        Organization_select,
        users_admin_select
    },
    created() {
        EventBus.$on("edit_equipment", this.edit_doc);
        EventBus.$on('remove_equipment',this.delete_from_list);
        
        if(parseInt(this.show_id) > 0) {
            this.edit_doc(this.show_id)
        }
        
    },
    
    props : {
        show_id: {
            type : Number | String,
            default : 0,
        }
    },
    
    data() {
        return {
            modal_position: "right",
            is_show_modal: false,
            is_load: false,
            
            doc: {
                id : 0,
                tov_id : null,
                type_id : null,
                description : "",
                number : "",
                price : 0,
                comment : "",
                user_id : null,
            },
        }
    },
    
    methods: {
        
        set_user_id(id) {
            this.set_item_param('user_id',id);
        },
        
        set_admin_user_id(id) {
            this.set_item_param('init_user',id);
        },
        
        set_tov_id(id) {
            this.set_item_param('tov_id',id);
        },
        
        set_type_id(id) {
            this.set_item_param('type_id',id);
        },
        
        set_item_param(type,val){
            console.log('set_type',type,val);
            if(this.doc.hasOwnProperty(type)) {
                this.doc[type] = val;
            }
        },
        
        close_modal() {
            this.close();
        },
        
        close() {
            this.doc = this.default_item;
            this.is_show_modal = false;
        },
        
        edit_doc(doc_id) {
            this.load_item(doc_id);
        },
        
        delete_from_list(id)
        {
            this.doc.id = id;
            this.remove_item();
        },
        
        async remove_item() {
            const is_ok = confirm_imc('Видалити ?');
            is_ok.then(res => {
                api.delete('/equipment/' + this.doc.id).then(({data}) => {
                    if (data.status === "operation_success") {
                        window.location.reload();
                    }
                }).catch(err => {
                    if (err.response && err.response.hasOwnProperty('data')) {
                        EventBus.$emit('show_toast', {
                            err: err.response.data.message,
                            type: "danger",
                            title: err.response.data.status
                        });
                    } else {
                        EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                    }
                })
                    .finally(() => {
                        IMC_CORE.hideloading();
                        this.close();
                    });
            });
        },
        
        async load_item(id) {
            this.is_load = true;
            this.doc = this.default_item;
            IMC_CORE.showloading();
            await api.get('/equipment/' + id).then(({data}) => {
                this.is_show_modal = true;
                if (data.status === "operation_success") {
                    this.doc = data.data;
                }
            }).catch(err => {
                if (err.response && err.response.hasOwnProperty('data')) {
                    EventBus.$emit('show_toast', {
                        err: err.response.data.message,
                        type: "danger",
                        title: err.response.data.status
                    });
                } else {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                }
            })
                .finally(() => {
                    IMC_CORE.hideloading();
                    this.is_load = false;
                });
        },
        
        async save_doc() {
            await api.put('/equipment/' + this.doc.id,this.doc).then(({data}) => {
                window.location.reload();
                this.close_modal();
            }).catch(err => {
                console.log(err);
                if (err.response && err.response.hasOwnProperty('data')) {
                    EventBus.$emit('show_toast', {
                        err: err.response.data.message,
                        type: "danger",
                        position : "b-toaster-top-right",
                        title: err.response.data.status
                    });
                } else {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                }
            })
            .finally(() => {
                IMC_CORE.hideloading();
                this.is_load = false;
            });
        }
    },
    
    computed: {
        default_item() {
            return {
                id          : 0,
            }
        },
       
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-xl";
            }
            
            return "modal-dialog-right modal-xl";
        },
    }
}
</script>


<style scoped>

</style>